import {
	createTheme,
	InputAdornment,
	makeStyles,
	TextField as MuiTextField,
	ThemeProvider,
} from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import PropTypes from "prop-types";

const useStyles = makeStyles({
	label: {
		fontFamily: "Poppins-Regular",
	},
});

const textFieldTheme = createMuiTheme({
	overrides: {
		MuiFormControl: {
			root: {
				minHeight: "40px",
			},
		},
		MuiInputBase: {
			root: {
				minHeight: "40px",
			},
		},
		MuiInputLabel: {
			root: {
				fontFamily: "Poppins-Regular",
				fontSize: "14px",
			},
		},
	},
});

const TextField = ({ label, ...props }) => {
	const classes = useStyles();
	return (
		<ThemeProvider theme={textFieldTheme}>
			<MuiTextField
				{...props}
				them
				fullWidth
				label={label}
				variant="outlined"
				classes={{
					root: classes.label,
				}}
				InputProps={{
					...props.InputProps,
					endAdornment: (
						<InputAdornment position="end">
							<SearchIcon />
						</InputAdornment>
					),
				}}
			/>
		</ThemeProvider>
	);
};

TextField.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
};

export default TextField;
